<!-- eslint-disable -->
<template lang="pug">
    .box
        div(v-if="!canShowBattle")
            | {{ $i18n.t('common.common_textInfo_pageNotAllowed') }}
        .box-body(v-else)
            .box-body__title {{ $i18n.t('battle.battle_selectGameType_title') }}
            .box-body__items
                router-link.button.button_orange(:to="{name: 'battle-trainings:index'}")
                    img(src="../../../assets/images/battles/training.svg")
                    span {{ $i18n.t('battle.battle_selectGameType_button_training') }}
                    .box-shadow_orange
                router-link.button.button_blue(:to="{name: 'battles:index'}")
                    img(src="../../../assets/images/battles/student.svg")
                    span {{ $i18n.t('battle.battle_selectGameType_button_battle') }}
                    .box-shadow_blue
                router-link.button.button_yellow(:to="{name: 'battle:achievements-list'}")
                    img(src="../../../assets/images/battles/medal.svg")
                    span {{ achievementsListButtonName }}
                    .box-shadow_yellow
</template>

<script>
    /*eslint-disable*/
    import canShowBattle from '../../../utils/battle/canShowBattle'

    export default {
        mixins: [canShowBattle],
        computed: {
            achievementsListButtonName () {
                return window.screen.width > 360
                    ? this.$i18n.t('battle.battle_selectGameType_button_achievementsList')
                    : this.$i18n.t('battle.battle_selectGameType_button_achievements');
            }
        }
    }
</script>

<style scoped lang="scss">
    .box {
        height: 100%;
        border-radius: 40px;
        background: #ffffff;
        box-shadow: 0 0 54px #51A552;
        display: flex;
        justify-content: center;
        align-items: center;
        @media screen and (max-width: 575px) {
            border-radius: 0;
            box-shadow: none;
        }
    }
    .box-body {
        @media screen and (max-width: 360px) {
            margin: 30px 0;
        }
    }
    .box-body__title {
        white-space: nowrap;
        text-align: center;
        font-family: 'Appetite';
        font-size: 32px;
        line-height: 42px;
        color: #2187FF;
        margin-bottom: 15px;
        @include media($sm) {
            font-size: 42px;
        }
        @media screen and (max-width: 670px) {
            white-space: normal;
        }
    }
    .box-body__items {
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-direction: column;
    }
    .button {
        display: flex;
        justify-content: center;
        box-sizing: border-box;
        border-color: transparent;
        max-width: 360px;
        width: 100%;
        max-height: 107px;
        height: 100%;
        border-radius: 20px;
        padding: 30px;
        margin: 15px 0;
        position: relative;
        @include media($sm) {
            max-width: 420px;
        }
        span {
            align-self: center;
            font-family: 'Rubik';
            font-weight: 500;
            color: #ffffff;
            font-size: 24px;
            line-height: 38px;
            margin-left: .8rem;
            @include media ($sm) {
                font-size: 32px;
            }
            @media screen and (max-width: 360px) {
                margin-left: 0;
            }
        }
        img {
            min-width: 50px;
            min-height: 50px;
        }
    }
    .box-shadow_blue, .box-shadow_orange, .box-shadow_yellow {
        height: 100%;
        width: 100%;
        border-radius: 25px;
        position: absolute;
        top: 0;
        left: 0;
    }
    .button_orange {
        background: #FF7245;
        &:hover {
            box-shadow: 0 0 30px #FF7245;
        }
    }
    .box-shadow_orange {
        box-shadow: 0 7px 0 0 #FF5D2B;
    }
    .button_blue {
        background: #2187FF;
        &:hover {
            box-shadow: 0 0 30px #2187FF;
        }
    }
    .box-shadow_blue {
        box-shadow: 0 7px 0 0 #086DE3;
    }
    .button_yellow {
        background: #FFC052;
        &:hover {
            box-shadow: 0 0 30px #FFC052;
        }
    }
    .box-shadow_yellow {
        box-shadow: 0 7px 0 0 #F8AC27;
    }
</style>
